import { connect } from 'react-redux'
import { Component } from 'macguffin'

import pick1 from "assets/rules/rules_pick01.mp4"
import pick2 from "assets/rules/rules_pick02.mp4"
import pick3 from "assets/rules/rules_pick03.mp4"

import scatter from "assets/rules/rules_scatter.mp4"
import marslanding from "assets/rules/rules_marslanding.mp4"

import BackgroundImage from "utils/BackgroundImage"

import { RTP } from 'config'

const rulesWildStyle = {
    position: "relative",
    backgroundPosition: "center"
}

const rulesScatterStyle = {
    position: "relative",
    backgroundPosition: "center"
}

const rulesBoosetsStyle = {
    position: "relative",
    backgroundPosition: "center"
}

@connect(state => ({
    locale: state.session.locale
}), {})
export default class Rules extends Component {

    render() {
        const { locale } = this.props
        const localeSE = locale.toUpperCase() === 'SV_SE'

        return <div className="rulesContainer">
            <div className="gameRulesContainer">
                <h1> {this.t('game.rules.header')} </h1>
                <p dangerouslySetInnerHTML={{ __html: this.t('game.rules.rule1') }} />
                <p dangerouslySetInnerHTML={{ __html: this.t('game.rules.rule2') }} />
                <p dangerouslySetInnerHTML={{ __html: this.t('game.rules.rule3') }} />
                <p dangerouslySetInnerHTML={{ __html: this.t('game.rules.rule4') }} />
                <p dangerouslySetInnerHTML={{ __html: this.t('game.rules.rule5') }} />
                <p dangerouslySetInnerHTML={{ __html: this.t('game.rules.rule6') }} />
                <p dangerouslySetInnerHTML={{ __html: this.t('game.rules.rule7') }} />

                <p dangerouslySetInnerHTML={{ __html: this.t('game.rules.rtp', { RTP }) }} />
                <p dangerouslySetInnerHTML={{ __html: this.t('rules.gamerulesContent') }} />
                
                <p dangerouslySetInnerHTML={{ __html: `- ${this.t('game.rules.rule9')}` }} />
                <p dangerouslySetInnerHTML={{ __html: `- ${this.t('game.rules.rule10')}` }} />
                <p dangerouslySetInnerHTML={{ __html: this.t('game.rules.rule11') }} />
                <p dangerouslySetInnerHTML={{ __html: this.t('game.rules.rule12') }} />
            </div>
            <div className="cometRulesContainer">
                <h1> {this.t('rules.respins')} </h1>
                <BackgroundImage className="cometRulesWild" assetName="rulesWild" style={rulesWildStyle} />
                <p dangerouslySetInnerHTML={{ __html: this.t('rules.respinsContent') }} />
            </div>
            <div className="freespinsContainer">
                <h1> {this.t('rules.freespins')} </h1>
                <p> {this.t('rules.freespinsContent')} </p>
                <div style={{ width: '100%' }}>
                    <video autoPlay loop playsInline muted width="60%">
                        <source src={scatter} type="video/mp4" />
                    </video>
                </div>
            </div>
            <div className="pickmodesContainer">
                <h1>
                    {this.t('rules.pickmode')} 1
                </h1>
                <div style={{ width: '100%' }}>
                    <video autoPlay loop playsInline muted width="60%" >
                        <source src={pick1} type="video/mp4" />
                    </video>
                </div>
                <p>
                    {this.t('rules.pick1')}
                </p>
                <h1 style={{ marginTop: '3%', width: '100%' }}>
                    {this.t('rules.pickmode')} 2
                </h1>
                <div style={{ width: '100%' }}>
                    <video autoPlay loop playsInline muted width="60%">
                        <source src={pick2} type="video/mp4" />
                    </video>
                </div>
                <p> {this.t('rules.pick2')} </p>
                <h1 style={{ marginTop: '3%', width: '100%' }}>
                    {this.t('rules.pickmode')} 3
                </h1>
                <div style={{ width: '100%' }}>
                    <video autoPlay loop playsInline muted width="60%">
                        <source src={pick3} type="video/mp4" />
                    </video>
                </div>
                <p> {this.t('rules.pick3')} </p>
            </div>
            <div className="progressContainer">
                <BackgroundImage className="progressMarsSymbol" assetName="rulesScatter" style={rulesScatterStyle} />
                <p> +{this.t('rules.freespinAward')} </p>
                {!localeSE &&
                    <div>
                        <BackgroundImage className="progressBoosters" assetName="rulesBoosters" style={rulesBoosetsStyle} />
                        <p dangerouslySetInnerHTML={{ __html: this.t('rules.boosterContent') }} />
                    </div>
                }
            </div>
            <div className="jackpotContainer">
                <h1> {this.t('freespins.jackpotDraw.jackpot')} </h1>
                <p dangerouslySetInnerHTML={{ __html: this.t('rules.jackpotContent') }} />
                <div style={{ width: '100%' }}>
                    <video autoPlay loop playsInline muted width="60%">
                        <source src={marslanding} type="video/mp4" />
                    </video>
                </div>
            </div>
            <div className="howtoplayContainer">
                <h1> {this.t('rules.howtoplay.title')} </h1>
                <p dangerouslySetInnerHTML={{ __html: this.t('rules.howtoplay.description1') }} />
                {!window.config.autoplayDisable && (
                    <React.Fragment>
                        <p>{this.t('rules.howtoplay.description.auto1')}</p>
                        <p>{this.t('rules.howtoplay.description.auto2')}</p>
                        <p>{this.t('rules.howtoplay.description.auto3')}</p>
                    </React.Fragment>
                )}
                {!window.config.hideHomeButton && (
                    <li>{this.t('rules.howtoplay.description.exit')}</li>
                )}

            </div>
        </div>
    }
}
